<script>
  import { navigate } from "svelte-navigator";
  import { auth } from "../firebase";

  import { getTeacherClass } from "../database/classes";
  import { user } from "../stores";

  let armReset, armDelete;
  let thisClass = getTeacherClass($user.uid);

  const resetClass = async () => {
    const doc = await getTeacherClass($user.uid);
    doc.ref.delete();
    navigate("/teach");
  };

  const deleteAccount = () => {
    auth.currentUser.delete();
  };

  console.log($user);
</script>

<nav class="panel">
  <p class="panel-heading">Your Profile</p>
  <div class="panel-block columns">
    <div class="column has-text-weight-semibold">Name</div>
    <div class="column">
      <span class="tag is-light">{$user.displayName}</span>
    </div>
  </div>
  <div class="panel-block columns">
    <div class="column has-text-weight-semibold">Email</div>
    <div class="column">
      <span class="tag is-light">{$user.email}</span>
    </div>
  </div>
  <div class="panel-block columns">
    <div class="column has-text-weight-semibold">Class ID</div>
    <div class="column">
      {#await thisClass}
        <progress class="progress is-small is-primary" max="100">15%</progress>
      {:then theClass}
        <span class="tag is-light">{theClass.id}</span>
      {/await}
    </div>
  </div>
  <div class="panel-block columns">
    <div class="column has-text-weight-semibold">UID</div>
    <div class="column">
      <span class="tag is-light">{$user.uid}</span>
    </div>
  </div>

  {#if armReset}
    <div class="panel-block">
      <button
        class="button is-danger is-outlined is-fullwidth"
        on:click={resetClass}
      >
        Are you sure?
      </button>
    </div>
  {:else}
    <div class="panel-block">
      <button
        class="button is-danger is-outlined is-fullwidth"
        on:click={() => (armReset = true)}
      >
        Reset class name
      </button>
    </div>
  {/if}
  {#if armDelete}
    <div class="panel-block">
      <button class="button is-danger is-fullwidth" on:click={deleteAccount}>
        Are you sure? This cannot be undone
      </button>
    </div>
  {:else}
    <div class="panel-block">
      <button
        class="button is-danger is-fullwidth"
        on:click={() => (armDelete = true)}
      >
        Delete Account
      </button>
    </div>
  {/if}
</nav>
